<template>
  <div class="book-card-background">
    <div class="book-card-background__inner">
      <BookCover :doc="doc" class="book-card-background__image" />
    </div>
  </div>
</template>

<script setup lang="ts">
import BookCover from '@/app/components/book/card/BookCover.vue'
import type { DocCoverProps } from '@/models/interfaces'

defineProps<{
  doc: DocCoverProps
}>()
</script>

<style lang="scss" scoped>
.book-card-background {
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;

  &__inner {
    width: 50px;
    height: 50px;
    overflow: hidden;
    transform: scale(50, 12);
  }

  &__image {
    transform: scale(3);
    filter: blur(40px) saturate(1.3);
    opacity: 0.3;
  }
}

.sf-safari .book-card-background__image {
  // `translateZ(0)` enables hardware acceleration, which
  // is necessary on Safari where `filter: blur()` is very slow
  // otherwise.
  transform: scale(3) translateZ(0);
}

.night-mode .book-card-background {
  background: $c-dark-2;

  &__inner {
    mix-blend-mode: color;
  }
}
</style>
